import { connect } from 'react-redux'
import Provider from './provider'
import { removeProvider } from '../../../../../../stores/providers/providers.actions'

const mapStateToProps = state => ({
  a: 'b'
})

const mapDispatchToProps = (dispatch, { id }) => ({
  onRemove: () => dispatch(removeProvider(id))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Provider)
